import * as React from 'react';
import { StyleSheet } from 'react-native';
import Svg, { Defs, Ellipse, FeGaussianBlur, Filter } from 'react-native-svg';

import { Box } from '@/components/lib/components';

export const OvalGlow = ({
    x,
    y,
    width,
    height,
    color,
    opacity,
}: {
    x: number;
    y: number;
    width: number;
    height: number;
    color: string;
    opacity: number;
}) => {
    return (
        <Box style={[styles.glowContainer, { opacity }]} pointerEvents={'none'}>
            <Svg style={styles.svg}>
                <Defs>
                    <Filter id="blur" x="-50%" y="-50%" width="200%" height="200%">
                        <FeGaussianBlur stdDeviation="20" />
                    </Filter>
                </Defs>
                <Ellipse
                    cx={x + width / 2}
                    cy={y + height / 2}
                    rx={width / 2}
                    ry={height / 2}
                    fill={color}
                    filter="url(#blur)"
                />
            </Svg>
        </Box>
    );
};

const styles = StyleSheet.create({
    svg: {
        flex: 1,
        width: '100%',
        height: '100%',
    },
    glowContainer: {
        position: 'absolute',
        width: '100%',
        height: '100%',
        opacity: 0.3,
    },
});
